function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import { useIsInverseVariant as a } from "../../theme-variant-context.js";
import { vars as l } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: n , size: r = 24  } = _param, t = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const e = a(), i = n !== null && n !== void 0 ? n : e ? l.colors.inverse : l.colors.neutralHigh;
    return /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: r,
        height: r,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: /* @__PURE__ */ o("path", {
            fill: i,
            d: "M17.697 11.023c.21.053.375.216.434.428a.627.627 0 01-.151.6L8.694 21.67a.584.584 0 01-.748.078.618.618 0 01-.23-.736l2.701-7.05-4.112-1.018a.6.6 0 01-.431-.423.626.626 0 01.142-.596l8.916-9.572a.582.582 0 01.754-.09c.24.16.336.474.23.746l-2.72 6.905 4.501 1.109zm-5.919 2.731l-1.893 4.944 6.504-6.74-4.146-1.022a.595.595 0 01-.389-.316.633.633 0 01-.022-.51l1.815-4.605L7.597 12l3.767.932a.6.6 0 01.39.314.638.638 0 01.024.507z"
        })
    }));
}, m = s;
export { m as default };
